import {EventEmitter, Injectable} from '@angular/core';
import {Config} from '../services/env.config';
import {HttpClient, HttpHeaders, HttpRequest} from '@angular/common/http';
import {Subject, Subscription} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CartService {
  uploadCartEmitter = new EventEmitter();
  categoryListEmitter = new EventEmitter();

  selectedProductFromPreFilledForm: any[] = [];
  uploadCartFormSub: Subscription;
  categorylist: any[] = [];
  categoryListSubscription: Subscription;
  cartProductCount: number = 0;
  cartProductQty: number = 0;
  cartProductPrice: number = 0;
   private cartUpdatedSource = new Subject<void>();
  cartUpdated$ = this.cartUpdatedSource.asObservable();
  constructor(private http: HttpClient) { }

  productDetail: any;
  cpHeaders = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Content-Security-Policy': 'default-src \'self\'; script-src \'self\'; style-src \'self\' \'unsafe-inline\'',
      'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload',
      'X-Frame-Options': 'DENY',
      'X-Content-Type-Options': 'nosniff',
      'Referrer-Policy': 'strict-origin-when-cross-origin',
      'Permissions-Policy': 'geolocation=(self), camera=(self),microphone=(self),payment=(self),usb=(self),accelerometer=(self)'
    })
  };
notifyCartUpdated() {
    this.cartUpdatedSource.next();
  }
  openUploadForm() {
    this.uploadCartEmitter.emit();
  }

  deleteItemsFromCart(ids): any {
    let DealUserName	= JSON.parse(sessionStorage.getItem('DealUserName'));
    let data = JSON.parse(sessionStorage.getItem('user'));
    let user = { UserName : data.UserName , DealUserName : DealUserName , ProductCode: ids}; 
    return this.http
      .post(Config.BaseEndpoint + '/RemoveProduct', JSON.stringify(user), this.cpHeaders)
      .toPromise()
      .then((response: any) => {
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  getInvoice(data): any { 
    return this.http
      .post(Config.BaseEndpoint + '/GetInvoiceDetails', JSON.stringify(data), this.cpHeaders)
      .toPromise()
      .then((response: any) => {
        // let res = "saved"
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  reOrderItems(data): any { 
    return this.http
      .post(Config.BaseEndpoint + '/Reorder', JSON.stringify(data), this.cpHeaders)
      .toPromise()
      .then((response: any) => {
        // let res = "saved"
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  deleteAllItemsFromCart(): any {
    let data = JSON.parse(sessionStorage.getItem('user'));
    let DealUserName	= JSON.parse(sessionStorage.getItem('DealUserName'));

    let user = { UserName : data.UserName , DealUserName : DealUserName }; 
    return this.http
      .post(Config.BaseEndpoint + '/RemoveAllCart', JSON.stringify(user), this.cpHeaders)
      .toPromise()
      .then((response: any) => {
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  saveNewProductToCart(productDetail): any {
    return this.http
      .post(Config.BaseEndpoint + '/AddtoCart', JSON.stringify(productDetail), this.cpHeaders)
      .toPromise()
      .then((response: any) => {
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  downloadInvoice(productDetail): any {
    let data = JSON.parse(sessionStorage.getItem('user'));
    let DealUserName	= JSON.parse(sessionStorage.getItem('DealUserName'));

    let user = { UserName : data.UserName , DealUserName : DealUserName , FromDate: productDetail.fromdate , ToDate:productDetail.toDate }; 
   if(productDetail.filetype == "Invoice") {
    return this.http
    .post(Config.BaseEndpoint + '/DownloadInvoice', JSON.stringify(user), this.cpHeaders)
    .toPromise()
    .then((response: any) => {
      return response;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
   } else {
    return this.http
    .post(Config.BaseEndpoint + '/DownloadOrder', JSON.stringify(user), this.cpHeaders)
    .toPromise()
    .then((response: any) => {
      return response;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
   }
   
  }


  updateQuantityForExistingProduct(cartDetail) {
    return this.http
      .put(Config.BaseEndpoint + '/cartDetails/updateCartDetails', JSON.stringify(cartDetail), this.cpHeaders)
      .toPromise()
      .then((response: any) => {
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  createSaleOrderFromCart(data) {
    return this.http
      .post(Config.BaseEndpoint + '/OrderCreation' , JSON.stringify(data), this.cpHeaders)
      .toPromise()
      .then((response: any) => {
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  getSaleOrderByDealerId(dealerId): any {
    return this.http.get(Config.BaseEndpoint + 'salesOrder/getSalesOrderForDealerId/' + dealerId)
      .toPromise()
      .then((response: any) => {
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  getPreSaleItemsDetail(preSaleOrderId): any {
    return this.http.get(Config.BaseEndpoint + 'preSalesOrderDetails/getPreSalesOrderDetailOnPreSalesOrderId/' + preSaleOrderId)
      .toPromise()
      .then((response: any) => {
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  uploadFile(formData: any, url) {
    const req = new HttpRequest('POST', Config.BaseEndpoint + url , formData, {responseType: 'text'} );
    return this.http.request<any>(req);
  }

  // getPreSaleOrderForDealer(page, orderNo): any {
  //   let data = JSON.parse(sessionStorage.getItem('user'));
  //   let DealUserName	= JSON.parse(sessionStorage.getItem('DealUserName'));

  //   let user = { UserName : data.UserName , DealUserName : DealUserName , PageNo: page , OrderNo:orderNo }; 
  //   return this.http.post(Config.BaseEndpoint + '/GetOrderList', JSON.stringify(user), this.cpHeaders)
  //     .toPromise()
  //     .then((response: any) => {
  //       return response;
  //     })
  //     .catch((error) => {
  //       return Promise.reject(error);
  //     });
  // }
getPreSaleOrderForDealer(page, orderNo, paymentFilter = '',IsIBD = 0): any {
    let data = JSON.parse(sessionStorage.getItem('user'));
    let DealUserName = JSON.parse(sessionStorage.getItem('DealUserName'));

    let user = { 
        UserName: data.UserName, 
        DealUserName: DealUserName, 
        PageNo: page, 
        OrderNo: orderNo,
        PaymentFilter: paymentFilter  ,
         IsIBD: IsIBD 
    }; 
    
    return this.http.post(Config.BaseEndpoint + '/GetOrderList', JSON.stringify(user), this.cpHeaders)
        .toPromise()
        .then((response: any) => {
            return response;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}
  getSalesOrderDetailBySaleOrderId(salesOrderId: number): any {
    let data = JSON.parse(sessionStorage.getItem('user'));
    let DealUserName	= JSON.parse(sessionStorage.getItem('DealUserName'));

    let user = { UserName : data.UserName , DealUserName : DealUserName, OrderNo: salesOrderId}; 
    return this.http
      .post(Config.BaseEndpoint + '/GetOrderDetails', JSON.stringify(user), this.cpHeaders)
      .toPromise()
      .then((response: any) => {
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);

      });
  }

  getCartDetailsForUser(): any {
    let data = JSON.parse(sessionStorage.getItem('user'));
    let DealUserName	= JSON.parse(sessionStorage.getItem('DealUserName'));
    let user = { UserName : data.UserName , DealUserName : DealUserName , CartFlag: false}; 
    return this.http
      .post(Config.BaseEndpoint + '/GetCartList', JSON.stringify(user), this.cpHeaders)
      .toPromise()
      .then((response: any) => {
        if (response == null || response.length == 0) {
          this.updateCount(0)
        }
        else {
          // this.updateCount(response);
        }
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  getCartCount(): any {
    let data = JSON.parse(sessionStorage.getItem('user'));
    let DealUserName	= JSON.parse(sessionStorage.getItem('DealUserName'));

    let user = { UserName : data.UserName , DealUserName : DealUserName , CartFlag: true}; 
    return this.http
      .post(Config.BaseEndpoint + '/GetCartList', JSON.stringify(user), this.cpHeaders)
      .toPromise()
      .then((response: any) => {
        if (response == null || response == 0) {
          this.updateCount(0)
        }
        else {
          if(response.ProductCount){
            this.updateCount(response);
          }
         
        }
        return response;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  private prodCount: number = 0;
  private prodQty: number = 0;
  private prodPrice: number = 0;
  public prodCountCountChange: Subject<number> = new Subject();
  public prodQtyQtyChange: Subject<number> = new Subject();
  public prodPricePriceChange: Subject<number> = new Subject();
  updateCount(count: any): void {
    if(count != 0) {
      if(count.ProductCount) {
        this.prodCountCountChange.next(count.ProductCount);
        this.prodQtyQtyChange.next(count.Qty);
        this.prodPricePriceChange.next(count.NetPrice);
      }
    } else {
      this.prodCountCountChange.next(this.prodCount);
      this.prodQtyQtyChange.next(this.prodQty);
      this.prodPricePriceChange.next(this.prodPrice);
    }
  }
}
